@if (message) {
	<div [ngClass]="{ show: show }" class="snackbar padding margin">
		<i class="fa-solid fa-circle-info margin-right-small"></i>
		{{ message }}
	</div>
}
